import { AccountEntity, LForEntity, SettingsEntity, TagEntity } from '@interpals/api-web';
import { createDraftSafeSelector, createSelector } from '@reduxjs/toolkit';

import { ReduxState } from 'redux/root-reducer';
import { LocationPoint } from 'redux/geolocation/reducer';

const selectSelf = (state: ReduxState) => state.account;

export const selectAccount = createDraftSafeSelector(selectSelf, (account): AccountEntity | null => account.data);

export const isEmailVerified = createDraftSafeSelector(selectSelf, (account) => account.data?.email.verified);
export const isNotSearchable = createDraftSafeSelector(
    selectSelf,
    (account): boolean | undefined => account.settings?.noindex,
);

export const selectAccountId = createDraftSafeSelector(selectSelf, (account): string => account.data?.id ?? '');
export const selectIsModerator = createSelector(selectSelf, (account) => account.data?.is_moderator ?? false);
export const selectAccountStatus = createSelector(selectSelf, (account) => account.data?.status);
export const selectAccountTokenStatus = createSelector(selectSelf, (account) => account.status);

export const getAccountEmail = createDraftSafeSelector(
    selectSelf,
    (account): string => account.data?.email.email || '',
);
export const selectAccountSettings = createDraftSafeSelector(
    selectSelf,
    (account): SettingsEntity | null => account.settings,
);
export const getAccountTagsSet = createDraftSafeSelector(
    selectSelf,
    (account): Set<string> => new Set(account.data?.user_tags?.map((tag: TagEntity): string => tag.name) || []),
);

export const selectAcccountCurrentCityPoint = createSelector(selectSelf, (account): LocationPoint | undefined => {
    if (account?.data?.location?.current?.latitude && account?.data?.location?.current?.longitude) {
        return {
            latitude: account.data.location.current.latitude,
            longitude: account.data.location.current.longitude,
        };
    }
});

export const selectIsOnboardingAboutDone = createSelector(selectAccount, (account): boolean => {
    return (account?.about.description.length ?? 0) > 0 && (account?.know.length ?? 0) > 0;
});

export const selectIsOnboardingMatchPrefsDone = createSelector(selectAccount, (account): boolean => {
    const lookingForGoals = account?.match_settings?.lfor;
    const selectedGoals = lookingForGoals
        ? Object.keys(lookingForGoals).filter((key) => lookingForGoals[key as keyof LForEntity])
        : [];

    return selectedGoals.length > 0;
});

export const selectIsOnboardingAvatarDone = createSelector(selectAccount, (account): boolean => {
    return account?.avatar !== null;
});

export const selectIsOnboardingComplete = createSelector(
    selectIsOnboardingAboutDone,
    selectIsOnboardingMatchPrefsDone,
    selectIsOnboardingAvatarDone,
    (about, wantToMeet, avatar) => about && wantToMeet && avatar,
);
